import { config } from '@/utils/postmonger';
// import useComponentsStore from '@/stores/components';
// import i18n from '@/i18n';
import { config as canvasConfig } from '@/utils/canvas';

export const PERSONALIZATION_REGEX = /#\{([^}]*)\}/g;

export const containsPersonalizationFields = (value = '') => !!(value || '').match(PERSONALIZATION_REGEX);

export const removePersonalizationFields = (value = '') => (value || '').replace(PERSONALIZATION_REGEX, '');

export const setTemplatePersonalizationFields = ({ sendData, template, recipientNumber }) => {
  const item = sendData;
  const dataString = JSON.stringify(template);
  // const { t } = i18n.global;

  dataString.match(PERSONALIZATION_REGEX)
    ?.map((key) => key.slice(2, -1))
    .forEach((key) => {
      const value = config.temporaryDataExtension[key];

      // if (!value) {
      //   const { openAlertDialog } = useComponentsStore();

      //   openAlertDialog({
      //     title: t('alert.notification'),
      //     content: t('alert.dataExtension', { key: `#{${key}}` }),
      //   });

      //   throw new Error('invalid dataExtension');
      // }

      item[key] = `{{${value}}}`;
    });

  const value = config.temporaryDataExtension[recipientNumber];

  // if (!value) {
  //   const { openAlertDialog } = useComponentsStore();

  //   openAlertDialog({
  //     title: t('alert.notification'),
  //     content: t('alert.dataExtension', { key: `#{${recipientNumber}}` }),
  //   });

  //   throw new Error('invalid dataExtension');
  // }

  item[recipientNumber] = `{{${value}}}`;

  return item;
};

export const setCoreDataTemplatePersonalizationFields = ({
  sendData,
  template,
  recipientNumber,
}) => {
  const item = sendData;
  const dataString = JSON.stringify(template);
  // const { t } = i18n.global;

  dataString.match(PERSONALIZATION_REGEX)
    ?.map((key) => key.slice(2, -1))
    .forEach((key) => {
      const value = canvasConfig.temporaryDataExtension[key];

      // if (!value) {
      //   const { openAlertDialog } = useComponentsStore();

      //   openAlertDialog({
      //     title: t('alert.notification'),
      //     content: t('alert.dataExtension', { key: `#{${key}}` }),
      //   });

      //   throw new Error('invalid dataExtension');
      // }

      item[key] = value;
    });

  const value = canvasConfig.temporaryDataExtension[recipientNumber];

  // if (!value) {
  //   const { openAlertDialog } = useComponentsStore();

  //   openAlertDialog({
  //     title: t('alert.notification'),
  //     content: t('alert.dataExtension', { key: `#{${recipientNumber}}` }),
  //   });

  //   throw new Error('invalid dataExtension');
  // }

  item[recipientNumber] = value;

  return item;
};
